export default {
  SET_LIST_CATALOG (state, catalog) {
    state.listCatalog = catalog
    state.loading = false
  },
  SET_LIST_CATALOG_FILTER (state, catalog) {
    if (catalog.categories && catalog.categories.length > 0) {
      state.listCatalogFilter.data = catalog.currentPage === 1 ? catalog.categories : [...state.listCatalogFilter.data, ...catalog.categories]
      state.listCatalogFilter.maxPage = catalog.maxPage
      state.listCatalogFilter.currentPage = catalog.currentPage
    } else {
      state.listCatalogFilter.data = []
      state.listCatalogFilter.maxPage = 1
      state.listCatalogFilter.currentPage = 1
    }
    state.loading = false
  },
  SET_LOADING_CATALOG (state, loading) {
    state.loading = loading
  },
  SET_LOADING_CATEGORIES (state, loading) {
    state.loadingCategories = loading
  }
}
